import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { InputWithRef } from '../input/input';
import { datePickerFormat } from '../../booking/constants';
import { classnames } from '../../../utils/classnames';
import Validators from '../../../utils/validation';

export default function CustomDatePicker({
  value,
  className,
  onChange,
  name,
  label,
  minDate,
  maxDate,
  showYearDropdown,
  openToDate = '',
  format = datePickerFormat.withMonth,
  disabled = false,
  isRequired = true,
}) {
  const [showYearObj, setShowYearObj] = useState({});
  const handleChange = (date) => {
    onChange(name, date);
  };

  useEffect(() => {
    if (showYearDropdown)
      setShowYearObj({
        showYearDropdown: true,
        dropdownMode: 'select',
        dateFormatCalendar: 'MMMM',
      });
  }, []);

  return (
    <DatePicker
      className={classnames(className)}
      name={name}
      minDate={minDate}
      maxDate={maxDate}
      selected={value}
      openToDate={openToDate}
      onSelect={handleChange}
      onChange={handleChange}
      dateFormat={format}
      disabled={disabled}
      customInput={
        <InputWithRef
          rules={!disabled && isRequired ? [Validators.required] : []}
          value={value}
          name={name}
          label={label}
          pointerEvent={false}
          readonly
          isDatePicker
        />
      }
      {...showYearObj}
    />
  );
}
